import { render, staticRenderFns } from "./ActionResultMessage.vue?vue&type=template&id=13bfd655&scoped=true&"
import script from "./ActionResultMessage.vue?vue&type=script&lang=js&"
export * from "./ActionResultMessage.vue?vue&type=script&lang=js&"
import style0 from "./ActionResultMessage.vue?vue&type=style&index=0&id=13bfd655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfd655",
  null
  
)

export default component.exports